import React from "react";
import { PanelRow, PanelSubheading, Link } from "@backslashbuild/pp-ui/dist/index.es";
import EmploymentIgnoredStatus from "./EmploymentIgnoredStatus";

export default function EmploymentIgnoredStatusRow({ accountNumber }) {
  const [dialogOpen, setDialogOpen] = React.useState(false);

  return (
    <>
      <PanelSubheading
        rightAction={
          <Link component={Link} onClick={() => setDialogOpen(true)}>
            Edit
          </Link>
        }
      >
        Ignore Employment
      </PanelSubheading>
      <PanelRow>
        <EmploymentIgnoredStatus
          accountNumber={accountNumber}
          open={dialogOpen}
          onClose={() => setDialogOpen(false)}
        />
      </PanelRow>
    </>
  );
}
